import { assign } from 'lodash';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, FormControl } from '@angular/forms';
import * as FlatModels from '@medsurf/flat-models';
import * as FlatFacades from '@medsurf/flat-facades';
import { ZodSharedValidator } from '@medsurf/flat-validators';

@Component({
    selector: 'medsurf-slide-edit-shared-description-form',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './shared-description-form.component.html',
    styleUrls: ['./shared-description-form.component.scss'],
    standalone: false
})
export class SharedDescriptionFormComponent {
  #isSubmitted = signal(false);
  #annotationLabel: FlatModels.AnnotationLabelEntityModels.AnnotationLabel;
  annotationLabelForm = new FormGroup(
    {
      description: new FormControl(''),
    },
    {
      validators: ZodSharedValidator.validate(
        FlatModels.AnnotationLabelEntityModels.AnnotationLabelSchema.pick({
          description: true,
        })
      ),
      updateOn: 'change'
    }
  );
  readonly FlatModels = FlatModels;

  constructor(public alertControlFacade: FlatFacades.AlertControlFacade,
              public slideAuthorFacade: FlatFacades.SlideAuthorFacade) {
    // Update Annotation Label
    this.slideAuthorFacade.currentSelectedSlideAnnotationLabel$.pipe(takeUntilDestroyed()).subscribe((annotationLabel) => {
      this.#annotationLabel = structuredClone(annotationLabel);
      if (this.#annotationLabel) {
        this.annotationLabelForm.reset(annotationLabel);
      }
      this.#isSubmitted.set(false);
    });
  }

  onSubmit() {
    if (this.#isSubmitted() || this.annotationLabelForm.invalid || !this.#annotationLabel) {
      return;
    }
    this.#isSubmitted.set(true);
    
    // Update Annotation Label
    const annotationLabel = assign(this.#annotationLabel, this.annotationLabelForm.value);
    this.slideAuthorFacade.requestUpdateAnnotationLabel(annotationLabel, 'history.page_update_description').subscribe({
      error: (result) => {
        ZodSharedValidator.handleError(result, this.alertControlFacade, this.annotationLabelForm);
        this.#isSubmitted.set(false);
      },
      next: () => {
        this.#isSubmitted.set(false);
      }
    });
  }
}
